import script from "./featureSection.vue?vue&type=script&setup=true&lang=js"
export * from "./featureSection.vue?vue&type=script&setup=true&lang=js"

import "./featureSection.vue?vue&type=style&index=0&id=6a93ee88&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6a93ee88"]])

export default __exports__